// extracted by mini-css-extract-plugin
var _1 = "PlayerHeader_backButton__8a014";
var _2 = "PlayerHeader_courseName__74c81";
var _3 = "PlayerHeader_left__b5c62";
var _4 = "PlayerHeader_progressBar__3fab1";
var _5 = "PlayerHeader_progressPercent__8bbaf";
var _6 = "PlayerHeader_progressWrapper__55ed8";
var _7 = "PlayerHeader_right__6703b";
var _8 = "PlayerHeader_root__c2729";
var _9 = "PlayerHeader_separator__d1715";
var _a = "PlayerHeader_userMenuTrigger__e97d5";
var _b = "PlayerHeader_userName__de076";
export { _1 as "backButton", _2 as "courseName", _3 as "left", _4 as "progressBar", _5 as "progressPercent", _6 as "progressWrapper", _7 as "right", _8 as "root", _9 as "separator", _a as "userMenuTrigger", _b as "userName" }
